<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
@if (apiRootStateResource$ | async; as apiRootStateResource) {
  <ozgcloud-spinner [stateResource]="apiRootStateResource">
    @if (apiRootStateResource.resource) {
      <alfa-header-container [apiRootStateResource]="apiRootStateResource" data-test-id="header"></alfa-header-container>

      <div class="relative ml-4 flex grow items-start justify-between sm:mt-16">
        <div class="mat-app-background relative grow"><router-outlet></router-outlet></div>

        <section class="mat-app-background right-nav">
          <ui-build-info
            [version]="apiRootStateResource.resource.version"
            [buildTime]="apiRootStateResource.resource.buildTime"
            [production]="apiRootStateResource.resource.production"
            data-test-id="build-info"
          />
        </section>
      </div>
    }
  </ozgcloud-spinner>
}
